/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-new */
// const Flickity = require('flickity');
import Flickity from 'flickity';
import BGLazyLoadFlickity from 'flickity-bg-lazyload';
// const BGLazyLoadFlickity = require('flickity-bg-lazyload');
// const IMGFlickity = require('flickity-imagesloaded');
// const GlideCarousel = require('@glidejs/glide');
import GlideCarousel from '@glidejs/glide';

// flickering fix for ie
const { focus } = Flickity.prototype;

const dragThresholdSize = 10;

Flickity.prototype.focus = function () {
	// use non-standard setActive for IE11. #651
	if (this.element.setActive) {
		this.element.setActive();
		return;
	}
	// use default
	// eslint-disable-next-line prefer-rest-params
	focus.apply(this, arguments);
};

// flickity height fix
// eslint-disable-next-line no-underscore-dangle
Flickity.prototype._createResizeClass = function () {
	setTimeout(() => {
		this.element.classList.add('flickity-resize');
	});
};
Flickity.createMethods.push('_createResizeClass');

const { resize } = Flickity.prototype;
Flickity.prototype.resize = function () {
	this.element.classList.remove('flickity-resize');
	resize.call(this);
	this.element.classList.add('flickity-resize');
};

/**
 * *******************************
 * header nav gallery carousel
 * *******************************
 */
const createNGCarousel = function (carouselContainer) {
	const gCarousel = carouselContainer.querySelector('.nav-gallery-carousel');
	new Flickity(gCarousel, {
		wrapAround: true,
		cellAlign: 'center',
		contain: true,
		pageDots: true,
		prevNextButtons: true,
		dragThreshold: dragThresholdSize,
	});
};

const initNGCarousel = () => {
	const navGalleryCarousels = document.querySelectorAll('.nav-gallery-container');

	navGalleryCarousels.forEach((elem) => {
		createNGCarousel(elem);
	});
};

/**
 * *******************************
 * banner carousel
 * *******************************
 */

const createBCarousel = function (carouselContainer) {
	const lCarousel = carouselContainer.querySelector('.banner-carousel');
	const locationTextEl = carouselContainer.querySelector('.location-text');

	new Flickity(lCarousel, {
		wrapAround: true,
		cellAlign: 'left',
		contain: true,
		autoPlay: 8000,
		pageDots: false,
		prevNextButtons: true,
		dragThreshold: dragThresholdSize,
		on: {
			select() {
				const slides = this.getCellElements();
				slides.forEach((slide) => {
					const contentEl = slide.querySelector('.carousel-content');
					const bgImageEl = slide.querySelector('.carousel-bg-image');
					if (contentEl.classList.contains('animate-moveInLeft')) {
						contentEl.classList.remove('animate-moveInLeft');
					}

					if (bgImageEl.classList.contains('animate-imageZoom')) {
						bgImageEl.classList.remove('animate-imageZoom');
					}
				});
				const carouselContentEl = this.selectedElement.querySelector('.carousel-content');
				const carouselBgImageEl = this.selectedElement.querySelector('.carousel-bg-image');
				carouselContentEl.classList.add('animate-moveInLeft');
				carouselBgImageEl.classList.add('animate-imageZoom');

				if (locationTextEl) {
					locationTextEl.textContent = carouselBgImageEl.parentNode.getAttribute('data-caption');
					// eslint-disable-next-line prettier/prettier
					locationTextEl.parentNode.style.width = `${locationTextEl.offsetWidth + 16}px`;
				}
			},
		},
	});
};

const bannerCarousels = document.querySelectorAll('.banner-carousel-container');
bannerCarousels.forEach((elem) => {
	createBCarousel(elem);
});

/**
 * *******************************
 * link blocks carousel
 * *******************************
 */
const linkBlocksCarousels = document.querySelectorAll('.link-blocks-carousel-container');

const createLBCarousel = function (carouselContainer) {
	const aCarousel = carouselContainer.querySelector('.link-blocks-carousel');
	if (aCarousel) {
		new Flickity(aCarousel, {
			wrapAround: true,
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			prevNextButtons: false,
			watchCSS: true,
			dragThreshold: dragThresholdSize,
		});
	}
};

linkBlocksCarousels.forEach((elem) => {
	createLBCarousel(elem);
});

/**
 * *******************************
 * holidays carousel
 * *******************************
 */

const createHCarousel = function (carouselContainer) {
	const hCarousel = carouselContainer.querySelector('.holidays-carousel');
	return new Flickity(hCarousel, {
		wrapAround: true,
		cellAlign: 'left',
		contain: true,
		pageDots: false,
		prevNextButtons: true,
		watchCSS: true,
		dragThreshold: dragThresholdSize,
	});
};

/**
 * *******************************
 * inspiration carousel
 * *******************************
 */

if (document.querySelector('.inspiration-carousel')) {
	const glideInspiration = new GlideCarousel('.inspiration-carousel', {
		type: 'carousel',
		autoplay: 6000,
		gap: 0,
		startAt: 0,
		perView: 1,
	});

	glideInspiration.mount({
		CustomActiveClass: (Glide, Components, Events) => {
			const Component = {
				mount() {
					this.changeActiveSlide();
				},
				changeActiveSlide() {
					const slide = Components.Html.slides[Glide.index];

					// Add active animation to next index
					slide.classList.add('glide_slide-is-active');
					setTimeout(() => {
						slide.classList.add('animated');
					}, 600);

					// Remove from all existing indices
					[...slide.parentNode.children]
						.filter((child) => child !== slide)
						.forEach((sibling) => {
							sibling.classList.remove('animated');

							setTimeout(() => {
								sibling.classList.remove('glide_slide-is-active');
							}, 600);
						});

					const lastIndex = Components.Html.slides.length - 1;

					// Fix for infinite scroll when next card
					if (Glide.index === 0) {
						Components.Html.slides[lastIndex].nextElementSibling.classList.add('glide_slide-is-active');
					}

					// Fix for infinite scroll when prev card
					if (Glide.index === lastIndex) {
						Components.Html.slides[0].previousElementSibling.classList.add('glide_slide-is-active');
					}
				},
			};
			Events.on('run', () => {
				Component.changeActiveSlide();
			});
			return Component;
		},
	});
}

/**
 * *******************************
 * gallery carousel
 * *******************************
 */
const galleryCarousels = document.querySelectorAll('.gallery-carousel-container');

const createGCarousel = function (carouselContainer) {
	const gCarousel = carouselContainer.querySelector('.gallery-carousel');
	let gCarouselStatus = null;
	if (carouselContainer.closest('.text-image-block')) {
		gCarouselStatus = carouselContainer.closest('.text-image-block').querySelector('.gallery-carousel-status');
	}
	new BGLazyLoadFlickity(gCarousel, {
		wrapAround: true,
		cellAlign: 'left',
		contain: true,
		pageDots: !!gCarousel.getAttribute('data-show-dots'),
		prevNextButtons: true,
		bgLazyLoad: 1,
		dragThreshold: dragThresholdSize,
		on: {
			select() {
				const selectedImageCaption = this.selectedElement.getAttribute('data-caption');
				if (gCarouselStatus) {
					if (selectedImageCaption) {
						gCarouselStatus.classList.remove('hidden');
						gCarouselStatus.textContent = selectedImageCaption;
					} else {
						gCarouselStatus.classList.add('hidden');
					}
				}
			},
		},
	});
};

galleryCarousels.forEach((elem) => {
	createGCarousel(elem);
});

/**
 * *******************************
 * destinations carousel
 * *******************************
 */

const destinationsCarousels = document.querySelectorAll('.destinations-carousel-container');

const createDCarousel = function (carouselContainer) {
	const tdCarousel = carouselContainer.querySelector('.destinations-carousel');
	return new Flickity(tdCarousel, {
		wrapAround: true,
		cellAlign: 'left',
		contain: true,
		pageDots: false,
		prevNextButtons: true,
		watchCSS: true,
		dragThreshold: dragThresholdSize,
	});
};

destinationsCarousels.forEach((elem) => {
	createDCarousel(elem);
});

/**
 * *******************************
 * things to do carousel
 * *******************************
 */

const thingsToDoCarousels = document.querySelectorAll('.things-todo-carousel-container');

const createTTDCarousel = function (carouselContainer) {
	const ttdCarousel = carouselContainer.querySelector('.things-todo-carousel');
	return new Flickity(ttdCarousel, {
		wrapAround: true,
		cellAlign: 'left',
		contain: true,
		pageDots: false,
		prevNextButtons: true,
		watchCSS: true,
		dragThreshold: dragThresholdSize,
	});
};

thingsToDoCarousels.forEach((elem) => {
	createTTDCarousel(elem);
});

/**
 * *******************************
 * gallery banner carousel
 * *******************************
 */

const galleryBannerCarousels = document.querySelectorAll('.gallery-banner-carousel-container');

const createGBCarousel = function (carouselContainer) {
	const gbCarousel = carouselContainer.querySelector('.gallery-banner-carousel');
	const hasThreeImages = gbCarousel.classList.contains('three-images');
	new BGLazyLoadFlickity(gbCarousel, {
		wrapAround: true,
		cellAlign: 'left',
		contain: true,
		pageDots: false,
		prevNextButtons: true,
		bgLazyLoad: hasThreeImages ? 3 : 1,
		dragThreshold: dragThresholdSize,
	});
};

galleryBannerCarousels.forEach((elem) => {
	createGBCarousel(elem);
});

/**
 * *******************************
 * special offers carousel
 * *******************************
 */

const specialOffersCarousels = document.querySelectorAll('.special-offers-carousel-container');

const createSOCarousel = function (carouselContainer) {
	const soCarousel = carouselContainer.querySelector('.special-offers-carousel');
	return new Flickity(soCarousel, {
		wrapAround: true,
		cellAlign: 'left',
		contain: true,
		pageDots: true,
		prevNextButtons: true,
		dragThreshold: dragThresholdSize,
	});
};

specialOffersCarousels.forEach((elem) => {
	createSOCarousel(elem);
});

/**
 * *******************************
 * day plans carousel
 * *******************************
 */

const createDParousel = function (carouselContainer) {
	if (carouselContainer) {
		const tpCarousel = carouselContainer.querySelector('.day-plan-carousel');
		return new Flickity(tpCarousel, {
			wrapAround: true,
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			prevNextButtons: true,
			watchCSS: true,
			dragThreshold: dragThresholdSize,
		});
	}
};

/**
 * *******************************
 * gallery tabs carousel
 * *******************************
 */
const createGTCarousel = function (carouselContainer) {
	const gCarousel = carouselContainer.querySelector('.tabs-carousel');
	new Flickity(gCarousel, {
		wrapAround: true,
		cellAlign: 'left',
		contain: true,
		pageDots: false,
		prevNextButtons: true,
		watchCSS: true,
		dragThreshold: dragThresholdSize,
	});
};

/**
 * *******************************
 * top hotels carousel
 * *******************************
 */
const topHotelsCarousels = document.querySelectorAll('.top-hotels-carousel-container');

const createTHCarousel = function (carouselContainer) {
	const thCarousel = carouselContainer.querySelector('.top-hotels-carousel');
	new Flickity(thCarousel, {
		wrapAround: true,
		cellAlign: 'left',
		contain: true,
		pageDots: false,
		prevNextButtons: false,
		watchCSS: true,
		dragThreshold: dragThresholdSize,
	});
};

topHotelsCarousels.forEach((elem) => {
	createTHCarousel(elem);
});

/**
 * *******************************
 * tab image text carousel
 * *******************************
 */

const textImageCarousels = document.querySelectorAll('.image-text-carousel-container');

const createTITCarousel = function (carouselContainer) {
	const titCarousel = carouselContainer.querySelector('.image-text-carousel');
	new Flickity(titCarousel, {
		wrapAround: true,
		cellAlign: 'left',
		contain: true,
		pageDots: false,
		prevNextButtons: true,
		adaptiveHeight: true,
		dragThreshold: dragThresholdSize,
	});
};

textImageCarousels.forEach((elem) => {
	createTITCarousel(elem);
});

export { initNGCarousel, createHCarousel, createGTCarousel, createDParousel };
